export enum InstanceType {
  JOBS = 'JOBS',
  JOB_DETAILS_UPDATE = 'JOB_DETAILS_UPDATE',
  JOB_AI_ENHANCEMENT = 'JOB_AI_ENHANCEMENT',
  DUPLICATE_JOB = 'DUPLICATE_JOB',
  DELETE_JOB = 'DELETE_JOB',
  // Add more instance types as needed
}

export const Instances = {
  [InstanceType.JOBS]: {
    endpoint: '/api/jobPostings',
    name: 'GetJobs',
  },
  [InstanceType.JOB_DETAILS_UPDATE]: {
    endpoint: '/api/JobPostings',
    name: 'UpdateJobDetails',
  },
  [InstanceType.JOB_AI_ENHANCEMENT]: {
    endpoint: '/api/JobPostings',
    name: 'GetAiEnhancement',
  },
  [InstanceType.DUPLICATE_JOB]: {
    endpoint: '/api/JobPostings',
    name: 'DuplicateJob',
  },
  [InstanceType.DELETE_JOB]: {
    endpoint: '/api/JobPostings',
    name: 'DeleteJob',
  },
} as const;
